import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Phone16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M10.4178 15.0571L10.4254 15.0615C11.0957 15.4883 11.8915 15.6737 12.6814 15.587C13.4713 15.5004 14.2081 15.1469 14.77 14.585L15.2584 14.0965C15.4766 13.8781 15.5991 13.582 15.5991 13.2733C15.5991 12.9645 15.4766 12.6684 15.2584 12.45L13.2004 10.3932C12.9819 10.175 12.6858 10.0525 12.3771 10.0525C12.0684 10.0525 11.7723 10.175 11.5538 10.3932C11.4458 10.5013 11.3175 10.5871 11.1763 10.6457C11.0351 10.7042 10.8837 10.7344 10.7308 10.7344C10.578 10.7344 10.4266 10.7042 10.2854 10.6457C10.1442 10.5871 10.0159 10.5013 9.90788 10.3932L6.61474 7.09942C6.39657 6.88097 6.27402 6.58486 6.27402 6.27613C6.27402 5.9674 6.39657 5.67129 6.61474 5.45285C6.7229 5.34482 6.8087 5.21653 6.86724 5.07532C6.92579 4.93411 6.95592 4.78274 6.95592 4.62988C6.95592 4.47701 6.92579 4.32565 6.86724 4.18443C6.8087 4.04322 6.7229 3.91494 6.61474 3.80691L4.55731 1.74696C4.33887 1.52879 4.04276 1.40625 3.73403 1.40625C3.4253 1.40625 3.12919 1.52879 2.91075 1.74696L2.42227 2.23544C1.86047 2.79737 1.50704 3.53404 1.4203 4.32389C1.33355 5.11374 1.51869 5.90955 1.94515 6.58001L1.95019 6.58759C4.20542 9.92605 7.07985 12.8011 10.4178 15.0571Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
